import type { PostLike } from '~/hooks/useLoaders/usePostInsights';
import type { Admin } from '~/interfaces/admin';
import type { Subscription } from '~/interfaces/subscriptions';

export const getIsLiked = (likes: PostLike[], admin?: Admin, subscription?: Subscription): boolean => {
  if (likes.length === 0) {
    return false;
  }

  if (!admin && !subscription) {
    return false;
  }

  return likes
    .filter((like) => like.liked === true)
    .some((like) => like.user_id === admin?.id || like.subscription_id === subscription?.id);
};
